export default {
  GET_INFOBIP_ACCOUNTS: (state) => state.infobip_accounts,
  GET_INFOBIP_ACCOUNT: (state) => state.infobip_account,
  GET_ACTIVE_INFOBIP_ACCOUNT: (state) => state.active_infobip_account,
};
